import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CeaRechazo {
  static nuevoRechazo (brutoValues = {}) {
    const {
      numero,
      pesoBruto,
      balanza,
      balancero,
      motivoRechazo
    } = brutoValues
    // falta motivo de rechazo
    const axios = getAxiosInstance()
    const promise = axios.post(`carga_entrante_automotor_rechazada_en_pesado`,
      `{"valores": {"carta_de_porte_automotor": "${numero}", 
      "balanza_de_bruto": "${balanza}", "peso_bruto": "${pesoBruto}", 
      "balancero_de_bruto": "${balancero}", "rechazo_en_pesado": "${motivoRechazo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default CeaRechazo
